<template>
    <div class="container-fluid  pt-2">
        <div class="container-fluid  pt-2">
            <h4 class="text-weight-900">Customer Product Insights</h4>
                <b-table
            sticky-header="100vh"
            hover
            :items="customer_data"
            :fields="customerTable.fields"
            sort-icon-left
            responsive="sm"
            @row-clicked="customerTrxRowSelected"
            >
            <template #cell(index)="data">
                <span>{{ data.index + 1 }}</span>
            </template>
            <template #cell(total spent)="data">

                <span>{{ convertCurrencyToShillings(data.total_spent) }}</span>
            </template>
            </b-table>
        </div>
    </div>


</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
export default {
  name: 'customer-profile',

  data() {
    return {
      customer_data: [],
      customerTable: {
        fields: [
          "index",
          { key: "customer_name", sortable: true },
        { key: "phone", sortable: true },
          { key: "total_qty", sortable: true },
          { key: "total_spent", sortable: true },
          { key: "last_purchased_at", sortable: true },
          { key: "purchase_count",label:'Orders', sortable: true }
        ],
        items: []
      },
    };
  },
   computed: {

         ...mapGetters(['userDetails']),
   },
  mounted() {
    this.getcustomer_data();
  },

  methods: {
    getProductIdFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('id');
    },
 customerTrxRowSelected(item) {
                window.location.replace('/customer?id=' + item.id)
            },
    async getcustomer_data() {
      const productId = this.getProductIdFromURL();

      try {
        const response = await axios.get('/api/product-insights/customers', {
          params: { product_id: productId }
        });

        const result = response.data;
        this.customer_data = result;



      } catch (error) {
        console.error('Error loading customer insights:', error);
      }
    },

    async downloadCustomerReport(customer_id) {
      try {
        const response = await axios.get('/api/customer-transaction-reports', {
          params: { customer_id },
          responseType: 'blob'
        });

        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const fileName = `Report-${moment().format('YYYY-MM-DD-HH-mm')}.pdf`;
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          alert('Error downloading report');
        }
      } catch (error) {
        console.error(error);
      }
    },

            EditCustomerInfo(e) {
                e.preventDefault();
                axios.post('/api/updatecustomer', {
                        ...this.customer_data
                    })
                    .then(result => {
                        if (result.status === 200) {
                            this.$root.$toasts.push({
                                type: 'success',
                                message: "Customer data updated successfully",
                            });
                            this.$refs['edit-customer-modal'].hide();
                            this.getCustomers()
                        } else {
                            this.$root.$toasts.push({
                                type: 'error',
                                message: "There was an error adding customer",
                            });
                        }
                    });
            },

            hasPermission(permissionName) {
                 return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },
    formatDate(date, format) {
      return moment(date).format(format);
    },
            EditCustomerModal() {
                this.$refs['edit-customer-modal'].show();
                this.$refs['customer_profile'].hide();
            },
  }
};
</script>
